export const SABOTEUR_DESCRIPTIONS = {
  Avoider: {
    title: 'Avoider',
    pattern:
      'Avoids conflict by saying “yes” to stay at peace, born from fearing discomfort.',
    impact: 'Fosters resentment, anxiety, and superficial connections.',
    howToNeutralize:
      'Speak up directly, accept brief discomfort, and address issues early.',
  },
  Pleaser: {
    title: 'Pleaser',
    pattern:
      'Seeks love by overhelping others, believing self-sacrifice is required.',
    impact: 'Leads to burnout, unmet needs, and hidden resentment.',
    howToNeutralize:
      'Set clear boundaries, assert your needs, and trust your intrinsic worth.',
  },
  'Hyper-Rational': {
    title: 'Hyper-Rational',
    pattern: 'Relies on logic over emotion, often to avoid messy feelings.',
    impact: 'Results in emotional isolation and weakened empathy.',
    howToNeutralize:
      'Practice emotional validation, listen actively, and balance facts with empathy.',
  },
  Controller: {
    title: 'Controller',
    pattern:
      'Micromanages to reduce anxiety, shaped by early chaos or betrayal.',
    impact: 'Creates stress, resistance, and hinders collaboration.',
    howToNeutralize:
      'Delegate tasks, embrace vulnerability, and build trust in others.',
  },
  Victim: {
    title: 'Victim',
    pattern: 'Uses suffering for attention, often from childhood neglect.',
    impact: 'Traps you in helplessness, loneliness, and negativity.',
    howToNeutralize:
      'Focus on personal agency, practice gratitude, and reclaim your power.',
  },
  Restless: {
    title: 'Restless',
    pattern:
      'Chases constant stimulation to avoid stillness, often from boredom or neglect.',
    impact: 'Leads to scattered focus, unfinished tasks, and mental fatigue.',
    howToNeutralize:
      'Slow down, commit to one task at a time, and sit with discomfort mindfully.',
  },
  'Hyper-Vigilant': {
    title: 'Hyper-Vigilant',
    pattern: 'Constantly scans for danger, driven by early unpredictability.',
    impact: 'Causes chronic anxiety, mistrust, and exhaustion.',
    howToNeutralize:
      'Ground yourself with facts, practice present-moment awareness, and rebuild trust gradually.',
  },
  'Hyper-Achiever': {
    title: 'Hyper-Achiever',
    pattern:
      'Ties self-worth to success, born from performance-driven upbringing.',
    impact: 'Fuels overwork, emotional distance, and fear of being ordinary.',
    howToNeutralize:
      'Celebrate effort over outcome, allow vulnerability, and connect emotionally with others.',
  },
  Stickler: {
    title: 'Stickler',
    pattern: 'Obsessed with perfection and order to avoid chaos.',
    impact: 'Creates rigidity, self-criticism, and stifles creativity.',
    howToNeutralize:
      'Practice flexibility, embrace imperfection, and focus on progress rather than flawless execution.',
  },
  Judge: {
    title: 'Judge',
    pattern:
      'Criticizes self and others harshly, often from unrealistic early expectations.',
    impact: 'Fuels shame, guilt, and activates other saboteurs.',
    howToNeutralize:
      'Cultivate self-compassion, challenge negative thoughts, and use mindfulness to interrupt judgmental loops.',
  },
};